import type { TreeSelectDesignTokens, TreeSelectTokenSections } from '@openng/optimus-ui-themes/types/treeselect';

export const root: TreeSelectTokenSections.Root = {
	placeholderColor: '{surface.200}',
	lg: {
		paddingY: '0.5rem',
	},
};

export default {
	root,
} satisfies TreeSelectDesignTokens;
